import React from 'react';
import { connect } from 'react-redux';
import Button from 'eventbrite_design_system/button/Button';

import {
    handleApplyFilter as handleApplyFilterAction,
    handleRemoveFilter as handleRemoveFilterAction,
} from '../actions/search';

const ExpandDedupedEventCTA = (props) => {
    return (
        <div className="eds-align--center">
            <Button
                style="link"
                onClick={() =>
                    props.handleApplyFilter({
                        eventNameHash: props.dedup.cluster.eventNameHash,
                    })
                }
            >
                {`+ ${props.dedup.count - 1} events similar to ${props.name}`}
            </Button>
        </div>
    );
};

const _mapDispatchToProps = (dispatch, ownProps) => ({
    handleApplyFilter: (...args) =>
        dispatch(handleApplyFilterAction(ownProps.history, ...args)),
    handleRemoveFilter: (...args) =>
        dispatch(handleRemoveFilterAction(ownProps.history, ...args)),
});

export default connect(undefined, _mapDispatchToProps)(ExpandDedupedEventCTA);
